export default __webpack_public_path__ + "static/media/label.frag.53ab2a12.glsl";